import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { CalendarOrder } from '../domains/entities/CalendarOrder';
import { CalendarOrderAdapter } from '../adapters/CalendarOrderAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

const orderStatusFilterItem = {
  ApprovedAwaitingDeliveryDate: true,
  ApprovalRequested: false,
  QuantityConfirmed: true,
  DeliveryDateConfirmed: true,
  PartialDelivery: true,
  Confirmed: true,
  Delivered: true,
  DeliveryDelayed: true,
};

/**
 *  「発注情報」を取ってきてUI表示ように加工するUseCase
 */
export class GetOrderUseCase {
  private static defaultPagingOptions: IPagingOptions = initPagingOptions(20);

  /**
   *  TableDataをBusinessManagerから抽出する
   * @param repository - 取引情報の永続化の責務を負うクラス
   * @param pagingOptions - ページングオプション
   * @param sortKey - ソートキー
   * @param isAsc - 昇順かどうか
   * @param filterItems - フィルター項目
   * @param targetDate - カレンダーの日付
   * @param isLimitless - 全件取得するかどうか
   */
  public static execute = async (
    repository: OrderRepository,
    pagingOptions?: IPagingOptions,
    sortKey?: string,
    isAsc?: boolean,
    filterItems?: FilterContentItem[],
    targetDate?: Date,
    isLimitless?: boolean
  ): Promise<INetworkResult<CalendarOrder[], IError>> => {
    const usePagingOptions = pagingOptions || GetOrderUseCase.defaultPagingOptions;
    const useFilterItem = filterItems ? FilterService.convertCustomerForecastFilterItems(filterItems) : undefined;
    const useOrderStatusFilterItem = FilterService.convertOrderStatusFilter(orderStatusFilterItem);
    const result = await repository.get(
      isAsc ? 'ASC' : 'DESC',
      usePagingOptions.pageSize,
      usePagingOptions.offset,
      false, // 未出力とか関係なく取得するのでFalse固定
      sortKey,
      useFilterItem,
      useOrderStatusFilterItem,
      targetDate ? `${targetDate?.getFullYear()}-${targetDate?.getMonth() + 1}-${targetDate?.getDate()}` : undefined,
      isLimitless
    );

    switch (result.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: CalendarOrderAdapter.adapt(result.status.data),
          },
        };
        break;
      case 'error':
        return {
          status: {
            type: 'error',
            error: result.status.error,
          },
        };
    }
  };
}
